import http from '../../../axios'
// 登录
export function phone_login(params) {
  return http.post('/sign-up/login-by-sms', params)
}
